var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseService } from "./baseService";
class DailyRosterService extends BaseService {
    constructor() {
        super(...arguments);
        this.controllerName = "roster";
    }
    getRoster(region, date, limit, offset) {
        return __awaiter(this, void 0, void 0, function* () {
            const headers = Object.assign(Object.assign({}, this.getDefaultHeaders()), { "Content-Type": "multipart/form-data" });
            const dateParam = date ? `date=${date}` : "";
            const regionParam = region ? `&region=${region}` : "";
            const limitParam = limit ? `&limit=${limit}` : "";
            const offsetParam = offset ? `&offset=${offset}` : "";
            const { data } = yield this.api.get(`/${this.controllerName}?${dateParam}${regionParam}${limitParam}${offsetParam}`, { headers });
            return { data };
        });
    }
}
export const dailyRosterService = new DailyRosterService();
//# sourceMappingURL=dailyRosterService.js.map